import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FLSelect extends Component {
	static slug = 'fl_select';

	static get propTypes() {
		return {
			_onChange: PropTypes.func.isRequired,
			name: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			fieldDefinition: PropTypes.object.isRequired,
		};
	}

	/**
	 * Handle input value change.
	 *
	 * @param {object} event
	 * @private
	 */
	_onChange = (event) => {
		this.props._onChange(this.props.name, event.target.value);
	};

	/**
	 * Inits the select field with the first option if no value is provided
	 * (e.g. when a Divi Module has just been created).
	 *
	 * @param value
	 * @private
	 */
	_init = (value) => {
		this.props._onChange(this.props.name, value);
	};

	render() {
		const optionsData = this.props.fieldDefinition.options;
		// If there are no options, return an error message
		if (optionsData.length === 0) {
			const errorMessage = (this.props.fieldDefinition.errors && this.props.fieldDefinition.errors.emptyOptions) || 'options list is empty';
			return (
				<div className="fl-select-error-msg">
					<span>{errorMessage}</span>
				</div>
			);
		}

		// The first option is selected by default if no value is provided or if the value is not in the options list
		let currentValue = this.props.value;
		const currentValueIsEmpty = currentValue.length === 0;
		const currentValueIsNotInOptions = Object.keys(optionsData).includes(currentValue) === false;
		if (currentValueIsEmpty || currentValueIsNotInOptions) {
			currentValue = Object.keys(optionsData)[0];
			this._init(currentValue);
		}

		const options = Object.keys(optionsData).map(id => (
			<option value={id} key={`fl-select-option-${id}`}>{optionsData[id]}</option>
		));
		return (
			<select
				id={`fl-select-${this.props.name}`}
				name={this.props.name}
				value={currentValue}
				className="fl-select"
				onChange={this._onChange}
				required
			>
				{options}
			</select>
		);
	}
}

export default FLSelect;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/custom-types/fl-select.js